import React from "react"

export default function MenuCardAltered(props) {
    const [cartState, changeCart] = React.useState(0)

    React.useEffect(() => {
        changeCart(props.amount)
    }, [])

    function changeCartStateUp() {
        changeCart(prevState => prevState + 1)
    }
    function changeCartStateDown() {
        if (cartState > 0) {
            changeCart(prevState => prevState - 1)
        }
    }

    function removeFromCart() {
        var array = [];
        array = JSON.parse(localStorage.getItem("cart")) || [];

        const index = array.findIndex(data => {
            return data.header == props.header
        })
        array.splice(index, 1)
        
        localStorage.setItem("cart", JSON.stringify(array));
        window.dispatchEvent(new Event("cart"));
        window.dispatchEvent(new Event("cart2"));
    }

    function addExtraToCart() {
        var array = [];
        array = JSON.parse(localStorage.getItem("cart")) || [];
        const index = array.findIndex(data => {
            return data.header == props.header
        })
        array[index].amount = cartState;
        localStorage.setItem("cart", JSON.stringify(array));
        window.dispatchEvent(new Event("cart"));
    }

    React.useEffect(() => {
        addExtraToCart()
    }, [cartState])

    return (
        <>
            <div className="bestsellerCard" data-aos="fade-up" data-aos-once="true" data-aos-delay={props.delay}>
                <div className="bestsellerCardImage">
                    <img src={props.image} alt="sushi" loading="lazy" />
                </div>
                <div className="bestsellerCardInfo1">
                    <p className="bestsellerCardHeader">{props.header}</p>
                    <p className="bestsellerCardPrice">{props.price}</p>
                </div>
                <p className="bestsellerCardDescription">{props.description}</p>
                <div className="betsellerCardButtons">
                <div className="bestsellerCardAddToCart" onClick={removeFromCart}>Remove</div>
                    <div className="bestsellerCardCartAmount">
                        <p onClick={changeCartStateUp}>+</p>
                        <p>{cartState}</p>
                        <p onClick={changeCartStateDown}>-</p>
                    </div>
                </div>
            </div>
        </>
    )
}